import { Button } from '@design/components/button/Button';
import clsx from 'clsx';

import styles from './WebsiteCard.module.scss';

interface WebsiteCardProps {
  id: string;
  title: string;
  url: string;
  favicon: string;
  handleRemove?: (id: string) => void;
}

export const WebsiteCard = ({
  id,
  title,
  url,
  favicon,
  handleRemove,
}: WebsiteCardProps) => {
  return (
    <div className={styles.cardWrapper}>
      <div className={clsx(styles.content, { [styles.onlyUrl]: !title })}>
        <img className={styles.favicon} src={favicon} alt={title} />
        <div className={styles.infoWrapper}>
          <span className={styles.title}>{title}</span>
          <span className={styles.url}>{url}</span>
        </div>
      </div>
      <Button
        iconName="Close"
        size="xsmall"
        variant="empty"
        onClick={() => {
          handleRemove?.(id);
        }}
      />
    </div>
  );
};
